import GenericReceipt from './GenericReceipt'
import ComplaintsReceipt from './ComplaintsReceipt'
import useSanitisedParams from '../../../hooks/useSanitisedParams'
import { useToFormId } from '../../../providers/FormDefinitionsProvider'

import config from '../../../config'

function Receipt() {
  const { formId: formSlugOrId } = useSanitisedParams<{ formId: string }>()

  const formId = useToFormId(formSlugOrId)

  switch (formId) {
    case config.FORMS.COMPLAINTS_FORM_ID:
      return <ComplaintsReceipt formId={formId} />
    default:
      return <GenericReceipt formId={formId} />
  }
}

export default Receipt
